<template>
  <NavBar pageName="ClientDetails"></NavBar>
  <div style="margin-top: 185px;">
  showAddNewClient:{{showAddNewClient}}
  showClientDetailsTable:{{showClientDetailsTable}}

  <AddNewClient v-if="showAddNewClient"
      :client_id="client_id"
      @reloadClientsEvent="reloadClientDetails(client_id)"
      @dialogClosedEvent="dialogClosedMethod"
      @dialogEscapedEvent="dialogEscapedMethod">

  </AddNewClient>

  <ClientDetails v-if="showClientDetailsTable"
                 :client_id="client_id"
                 @showClientDetailsReadyEvent="showClientDetails"
                 @reloadClientDetails="reloadClientDetails"
                 @showAddNewClientEvent="showAddNewClientMethod"
                 @showAddNewClientServiceEvent="openAddNewClientService" >

  </ClientDetails>

  <AddNewClientService v-if="showAddNewClientService"
                       :show="showAddNewClientService"
                       :initial-client-id="client_id"
                       @close="closeAddNewClientServiceHandle"
                       @serviceAdded="newServiceAddedEvent">
  </AddNewClientService>
  </div>
</template>


<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import {log} from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
// import store from "@/store";
import ClientDetails from "@/components/ClientDetails.vue";
import AddNewClient from "@/components/AddNewClient.vue";
import AddNewClientService from "@/components/AddNewClientService.vue";

// Components

export default defineComponent({
  name: 'DashBoard',
  components: {
    AddNewClientService,
    AddNewClient,
    ClientDetails,
    NavBar
  },
  data() {
    return {
      showToken:false,
      client:null,
      client_details:null,
      showAddNewClient:false,
      showAddNewClientService:false,
      token:'',
      client_id:this.$route.query.id,
      showClientDetailsTable:true,
    }
  },
  methods: {
    dialogClosedMethod() {
      this.showAddNewClient=false
      log("am primit emisia in clientInfo ca dialogClosedMethod")
    },
    closeAddNewClientServiceHandle() {
      this.showAddNewClientService=false
      this.showClientDetailsTable=true
      log("am primit emisia in clientInfo ca dialogClosedMethod")
    },
    newServiceAddedEvent() {
      this.showAddNewClientService=false
      this.showClientDetailsTable=false
      this.$nextTick(() => {
        setTimeout(()=>{this.showClientDetailsTable = true;},0)
      });
      log("am primit emisia in clientInfo ca dialogClosedMethod")
    },
    dialogEscapedMethod() {
      this.showAddNewClient=false
      this.showClientDetailsTable=true
      log("am primit emisia in clientInfo ca dialogEscapedMethod")
    },
    showClientDetails() {
      // alert("am primit emisia in clientInfo")
    },
    reloadClientDetails(payload) {
      log("am primit in reloadClientDetails emisia in clientInfo "+payload)
      this.showClientDetailsTable=false
      this.client_id=payload
      this.$nextTick(() => {
        setTimeout(()=>{this.showClientDetailsTable = true;},0)
      });
    },
    showAddNewClientMethod() {
      log("am primit in clientInfo emisia showAddNewClientEvent si lansam showAddNewClientMethod")
      this.showAddNewClient=true
      this.showClientDetailsTable=false
    },
    openAddNewClientService(client) {
      // alert(client.name)
      log(typeof client)
      log("am primit in clientInfo emisia openAddNewClientService cu param client")
      console.warn(client)
      this.client_details=client
      this.showAddNewClientService=true
      this.showClientDetailsTable=false
    },

  },
  computed: {
    // clientID() {
    //   // return this.$route.query.selected_client_id; // Access the `id` parameter from the URL
    //   alert('s.a schimbat this.client_id')
    //   return this.client_id; // Access the `id` parameter from the URL
    // }
  },
  created() {
    const {getLoggedIn, user, loggedIn, userAvatar,token}=useGetLoggedIn()
    getLoggedIn().then(()=>{
      // timestamp("autorizare in HomeloggedIn after getLoggedIn")
      log ("dupa created in ClientInfo avem:")
      log("autorizare in ClientInfo after getLoggedIn")
      log("user:")
      log(user)
      log("loggedIn: " + loggedIn.value)
      log("token: " + token.value)
      log("userAvatar: " + userAvatar)
      log(this.$route.query.id)
      this.client_id=this.$route.query.id;
      // Access the `id` parameter from the URL
      // alert("in client info am primit param: "+this.client_id)
      if(this.client_id == '' || this.client_id == null)
      {
        alert("no client_id param")
      }
      else
        {
          // alert("calea avem client_id"+this.client_id)
          this.showClientDetailsTable=true
        }

    })
  }
});
</script>
